const cameraList = [{
    classifyName: "清洁道路",
    list: [{
        id: 15,
        name: "厂区东北角球机",
        cameraName: "厂区东北角球机",
        classifyName: "清洁道路",
        nvrPassword: "hik12345",
        nvrUsername: "admin",
        //ipAddress: "30.100.103.5",
        nvrIp: "172.31.64.3",
        channelId: "15",
        cameraName: "厂区东北角球机",
        cameraIp: "30.100.103.5",
        password: "hik12345",
        top: 1350,
        left: 950,
        transform: 'rotate(270deg)',
    }, {
        id: 16,
        name: "新北区大门口球机",
        cameraName: "新北区大门口球机",
        classifyName: "清洁道路",
        nvrPassword: "hik12345",
        nvrUsername: "admin",
        //ipAddress: "30.100.103.6",
        nvrIp: "172.31.64.3",
        channelId: "16",
        cameraIp: "30.100.103.6",
        password: "hik12345",
        top: 1350,
        left: 820,
        transform: 'rotate(270deg)',
    }, {
        id: 5,
        name: "新北区制氧东门北角",
        cameraName: "新北区制氧东门北角",
        classifyName: "清洁道路",
        nvrPassword: "hik12345",
        nvrUsername: "admin",
        //ipAddress: "30.100.103.10",
        nvrIp: "172.31.64.3",
        channelId: "5",
        cameraIp: "30.100.103.10",
        password: "hik12345",
        top: 1380,
        left: 750,
        transform: 'rotate(270deg)',
    }, {
        id: 17,
        name: "老区炼钢东门球机",
        cameraName: "老区炼钢东门球机",
        classifyName: "清洁道路",
        nvrPassword: "hik12345",
        nvrUsername: "admin",
        //ipAddress: "30.100.102.7",
        nvrIp: "172.31.64.3",
        channelId: "17",
        cameraIp: "30.100.102.7",
        password: "hik12345",
        top: 1350,
        left: 720,
        transform: 'rotate(270deg)',
    }, {
        id: 18,
        name: "东门地泵东球机",
        cameraName: "东门地泵东球机",
        classifyName: "清洁道路",
        nvrPassword: "hik12345",
        nvrUsername: "admin",
        //ipAddress: "30.100.103.7",
        nvrIp: "172.31.64.3",
        channelId: "18",
        cameraIp: "30.100.103.7",
        password: "hik12345",
        top: 1250,
        left: 280,
        transform: 'rotate(270deg)',
    }, {
        id: 20,
        name: "850大道南球机",
        cameraName: "850大道南球机",
        classifyName: "清洁道路",
        nvrPassword: "hik12345",
        nvrUsername: "admin",
        //ipAddress: "30.100.102.3",
        nvrIp: "172.31.64.3",
        channelId: "20",
        cameraIp: "30.100.102.3",
        password: "hik12345",
        top: 1150,
        left: 150,
        transform: 'rotate(270deg)',
    }, {
        id: 19,
        name: "二号门门口球机",
        cameraName: "二号门门口球机",
        classifyName: "清洁道路",
        nvrPassword: "hik12345",
        nvrUsername: "admin",
        //ipAddress: "30.100.102.2",
        nvrIp: "172.31.64.3",
        channelId: "19",
        cameraIp: "30.100.102.2",
        password: "hik12345",
        top: 1040,
        left: 150,
        transform: 'rotate(270deg)',
    }, {
        id: 12,
        name: "原料小白楼球机",
        cameraName: "原料小白楼球机",
        classifyName: "清洁道路",
        nvrPassword: "hik12345",
        nvrUsername: "admin",
        //ipAddress: "30.100.102.4",
        nvrIp: "172.31.64.3",
        channelId: "12",
        cameraIp: "30.100.102.4",
        password: "hik12345",
        top: 1150,
        left: 330,
        transform: 'rotate(270deg)',
    }, {
        id: 10,
        name: "850炼钢8号门球机",
        cameraName: "850炼钢8号门球机",
        classifyName: "清洁道路",
        nvrPassword: "hik12345",
        nvrUsername: "admin",
        //ipAddress: "30.100.102.6",
        nvrIp: "172.31.64.3",
        channelId: "10",
        cameraIp: "30.100.102.6",
        password: "hik12345",
        top: 1200,
        left: 500,
        transform: 'rotate(270deg)',
    }, {
        id: 9,
        name: "能管中心球机",
        cameraName: "能管中心球机",
        classifyName: "清洁道路",
        nvrPassword: "hik12345",
        nvrUsername: "admin",
        //ipAddress: "30.100.102.11",
        nvrIp: "172.31.64.4",
        channelId: "9",
        cameraIp: "30.100.102.11",
        password: "hik12345",
        top: 1150,
        left: 480,
        transform: 'rotate(270deg)',
    }, {
        id: 7,
        name: "850大道铁路北球机",
        cameraName: "850大道铁路北球机",
        classifyName: "清洁道路",
        nvrPassword: "hik12345",
        nvrUsername: "admin",
        //ipAddress: "30.100.102.5",
        nvrIp: "172.31.64.4",
        channelId: "7",
        cameraIp: "30.100.102.5",
        password: "hik12345",
        top: 1180,
        left: 630,
        transform: 'rotate(270deg)',
    }, {
        id: 4,
        name: "850大道老北环交叉口球机",
        cameraName: "850大道老北环交叉口球机",
        classifyName: "清洁道路",
        nvrPassword: "hik12345",
        nvrUsername: "admin",
        //ipAddress: "30.100.103.2",
        nvrIp: "172.31.64.4",
        channelId: "4",
        cameraIp: "30.100.103.2",
        password: "hik12345",
        top: 1210,
        left: 730,
        transform: 'rotate(270deg)',
    }, {
        id: 3,
        name: "一炉上坡球机",
        cameraName: "一炉上坡球机",
        classifyName: "清洁道路",
        nvrPassword: "hik12345",
        nvrUsername: "admin",
        //ipAddress: "30.100.103.3",
        nvrIp: "172.31.64.4",
        channelId: "3",
        cameraIp: "30.100.103.3",
        password: "hik12345",
        top: 1000,
        left: 800,
        transform: 'rotate(270deg)',
    }, {
        id: 11,
        name: "一炉风机房门口球机",
        cameraName: "一炉风机房门口球机",
        classifyName: "清洁道路",
        nvrPassword: "hik12345",
        nvrUsername: "admin",
        //ipAddress: "30.100.103.4",
        nvrIp: "172.31.64.4",
        channelId: "11",
        cameraIp: "30.100.103.4",
        password: "hik12345",
        top: 1000,
        left: 685,
        transform: 'rotate(270deg)',
    }, {
        id: 6,
        name: "四炉坡道球机",
        cameraName: "四炉坡道球机",
        classifyName: "清洁道路",
        nvrPassword: "hik12345",
        nvrUsername: "admin",
        //ipAddress: "30.100.102.10",
        nvrIp: "172.31.64.4",
        channelId: "6",
        cameraIp: "30.100.102.10",
        password: "hik12345",
        top: 1020,
        left: 590,
        transform: 'rotate(270deg)',
    }, {
        id: 2,
        name: "新北区烧结球机",
        cameraName: "新北区烧结球机",
        classifyName: "清洁道路",
        nvrPassword: "hik12345",
        nvrUsername: "admin",
        //ipAddress: "30.100.103.8",
        nvrIp: "172.31.64.4",
        channelId: "2",
        cameraIp: "30.100.103.8",
        password: "hik12345",
        top: 820,
        left: 900,
        transform: 'rotate(270deg)',
    }, {
        id: 14,
        name: "厂区西北角球机",
        cameraName: "厂区西北角球机",
        classifyName: "清洁道路",
        nvrPassword: "hik12345",
        nvrUsername: "admin",
        //ipAddress: "30.100.103.9",
        nvrIp: "172.31.64.4",
        channelId: "14",
        cameraIp: "30.100.103.9",
        password: "hik12345",
        top: 800,
        left: 900,
        transform: 'rotate(270deg)',
    }, {
        id: 1,
        name: "GL3路口球机",
        cameraName: "GL3路口球机",
        classifyName: "清洁道路",
        nvrPassword: "hik12345",
        nvrUsername: "admin",
        //ipAddress: "30.100.102.8",
        nvrIp: "172.31.64.5",
        channelId: "1",
        cameraIp: "30.100.102.8",
        password: "hik12345",
        top: 780,
        transform: 'rotate(270deg)',
        left: 825,
    }, {
        id: 8,
        name: "原料门口球机",
        cameraName: "原料门口球机",
        classifyName: "清洁道路",
        nvrPassword: "hik12345",
        nvrUsername: "admin",
        //ipAddress: "30.100.102.9",
        nvrIp: "172.31.64.5",
        channelId: "8",
        cameraIp: "30.100.102.9",
        password: "hik12345",
        top: 800,
        left: 540,
        transform: 'rotate(270deg)',
    }, {
        id: 13,
        name: "西门地泵北球机",
        cameraName: "西门地泵北球机",
        classifyName: "清洁道路",
        nvrPassword: "hik12345",
        nvrUsername: "admin",
        //ipAddress: "30.100.102.12",
        nvrIp: "172.31.64.4",
        channelId: "13",
        cameraIp: "30.100.102.12",
        password: "hik12345",
        top: 820,
        left: 250,
        transform: 'rotate(270deg)',
    }]
}]


export default cameraList;